export default "__VITE_ASSET__DPlyj5kK__"